<!-- 资源访问 -->
<template>
  <div class="resource-access-chart">
    <div class="resource-access-chart-title">
      <div class="name">资源访问</div>
      <div class="week">
        <i class="el-icon-arrow-left" @click="reduceWeek"></i>
        {{ weeks }}周
        <i class="el-icon-arrow-right" @click="addWeek"></i>
      </div>
    </div>
    <div class="chart" id="resourceAccessChartId"></div>

  </div>
</template>
<script>
import { debounce } from "lodash";
import { getPlatformResourceVisitDayStatAPI } from "@/service/api.js"
export default {
  name: 'resource-access-chart',
  components: {
  },
  props: {
    //区域id
    regionId: {
      type: String,
      default: ''
    },
    regionType: {
      type: String,
      default: ''
    },
    //省id
    provinceId: {
      type: String,
      default: ''
    },
    //市id
    cityId: {
      type: String,
      default: ''
    },
    //区id
    districtId: {
      type: String,
      default: ''
    },
    //乡镇地址
    address: {
      type: String,
      default: ''
    },
    //学校id
    schoolId: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      //图表显示的周数
      weeks: "",
      //学年开始时间
      yearStartTime: "",
      //折型图数据
      dateList: [],
      //学年结束时间
      yearEndTime: "",
      dateParams: {
        start: "",
        end: ""
      },
      weekList: [],
      // 当前日期所在周数
      currentWeek: ""
    }
  },
  watch: {
    address() {
      this.getPlatformResourceVisitDayStat()
    },
    schoolId() {
      this.getPlatformResourceVisitDayStat()
    },
  },
  methods: {
    /**
     * @name 初始化图标
     */
    initEchart() {
      let _this = this;
      let date = [];
      let data = [];
      this.dateList.forEach((item) => {
        date.push(item.statsDate.substring(item.statsDate.length - 5))
        data.push(item.progress)
      })
      let dataSource = _this.$echarts.init(
        document.getElementById('resourceAccessChartId')
      );
      const option = {
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            var relVal =
              params.length > 1
                ? params[0].name +
                "</br>" +
                params[0].marker +
                Math.round(params[0].value * 100) / 100 +
                "%" +
                "</br>" +
                params[1].marker +
                Math.round(params[1].value * 100) / 100 +
                "%"
                : params[0].name +
                "</br>" +
                params[0].marker +
                Math.round(params[0].value * 100) / 100 +
                "%";
            return relVal;
          },
        },
        grid: {
          left: "20px",
          right: "40px",
          bottom: "0",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: date,
          boundaryGap: false,

          name: "时间",
          axisLabel: {
            margin: 15,
            interval: "auto",
            textStyle: {
              color: "#999",
              fontSize: "16px",
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#D6D6D6",
            },
          },
        },
        yAxis: {
          type: "value",
          name: "活跃指数（%）",
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#D6D6D6",
            },
          },
          axisLabel: {
            show: true,
            verticalAlign: "middle",
            textStyle: {
              color: "#999",
              fontSize: "16px",
            },
            formatter: "{value}%",
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#3D4772' // 替换为你想要的颜色值
            }
          },
        },
        series: [
          {
            data: data,
            type: "line",
            areaStyle: {
              normal: {
                color: 'linear-gradient(180deg, #44F0FF, #021132);'
              }
            },
            itemStyle: {
              normal: {
                color: {
                  type: 'radial',
                  x: 0.5,
                  y: 0.5,
                  r: 1,
                  colorStops: [
                    { offset: 0, color: '#ffffff' }, // 外部颜色
                    { offset: 1, color: '#83CCE7' } // 内部颜色
                  ]
                },
                lineStyle: {
                  color: "#83CCE7",
                  width: 2, //折线宽度
                },
              },
            },
            smooth: true
          }
        ],
      };
      dataSource.setOption(option);
      window.addEventListener("resize", function () {
        dataSource.resize();
      });
    },
    /**
     * @name 获取当前学年的开始时间结束时间
     */
    getYearTime() {
      //判断当前日期是在学年的前半段还是后半段
      let year = new Date().getFullYear();
      //当前时间大于学年开始时间，则处于学年的后半段
      if (new Date().getTime() < new Date(`${year}-08-10 00:00:00`).getTime()) {
        this.yearStartTime = `${year - 1}-08-10`;
        this.yearEndTime = `${year}-08-09`;
      } else {
        this.yearStartTime = `${year}-08-10`;
        this.yearEndTime = `${year + 1}-08-09`;
      }
      let startDate = new Date(this.yearStartTime);
      let currentDate = new Date();
      // 计算当前日期和学年开始日期相差的天数
      let daysDiff = Math.floor((currentDate - startDate) / (1000 * 60 * 60 * 24)) + 1 - 7 + startDate.getDay();
      // 计算当前日期所在周数
      this.currentWeek = Math.ceil(daysDiff / 7) + 1;
      this.weeks = this.currentWeek;
      this.dateParams = this.$utils.getWeekStartAndEnd(this.yearStartTime, this.yearEndTime, this.weeks);
      this.weekList = this.$utils.getDayArray(this.dateParams.start, this.dateParams.end);
      this.getPlatformResourceVisitDayStat();
    },
    /**
     * @name 减少周数
     */
    reduceWeek: debounce(function () {
      if (this.weeks == 1) {
        return
      }
      this.weeks--;
      this.dateParams = this.$utils.getWeekStartAndEnd(this.yearStartTime, this.yearEndTime, this.weeks);
      this.weekList = this.$utils.getDayArray(this.dateParams.start, this.dateParams.end);
      //获取平台资源访问按天统计数据
      this.getPlatformResourceVisitDayStat();
    }, 300),
    /**
     * @name 增加周数
     */
    addWeek: debounce(function () {
      if (this.weeks + 1 > this.currentWeek) {
        return this.$Message.success("已是当前最后一周啦");
      }
      this.weeks++
      this.dateParams = this.$utils.getWeekStartAndEnd(this.yearStartTime, this.yearEndTime, this.weeks);
      this.weekList = this.$utils.getDayArray(this.dateParams.start, this.dateParams.end);
      //获取平台资源访问按天统计数据
      this.getPlatformResourceVisitDayStat();
    }, 300),
    /**
     * @name 获取平台资源访问按天统计数据
    */
    async getPlatformResourceVisitDayStat() {
      let params = {
        regionId: this.regionId,
        provinceId: this.provinceId,
        cityId: this.cityId,
        districtId: this.districtId,
        address: this.address,
        schoolId: this.schoolId,
        startTime: this.dateParams.start ? `${this.dateParams.start} 00:00:00` : '',
        endTime: this.dateParams.end ? `${this.dateParams.end} 23:59:59` : '',
        regionType: this.regionType
      }
      this.dateList = [];
      //一周总访问量
      let totalacess = 0;
      try {
        const res = await getPlatformResourceVisitDayStatAPI(params);
        res.forEach((item) => {
          totalacess += item.rsViewNum;
        })
        this.weekList.forEach((item) => {
          let index = res.findIndex((value) => {
            return item == value.statsDate
          })
          if (index != -1) {
            this.dateList.push({
              ...res[index],
              progress: Number((res[index].rsViewNum / totalacess * 100).toFixed(2)) || 0
            })
          } else {
            this.dateList.push({
              progress: 0,
              statsDate: item,
              rsViewNum: 0,
            })
          }
        })
        //初始化表格
        this.initEchart();
      } catch (err) {
        // 处理错误
      }
    }
  },
  mounted() {
    //获取当前学年的开始时间结束时间
    this.getYearTime()
  }


}
</script>
<style lang="scss" scoped>
.resource-access-chart {
  width: 100%;
  height: 260px;
  background: rgba(9, 19, 66, 0.94);
  border-radius: 0px 0px 4px 4px;

  .resource-access-chart-title {
    background: url("~@/assets/images/qingxudataboard/title-bg.png") no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 13px 0 18px;

    .name {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
    }

    .week {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #B9E3F7;
      display: flex;
      align-items: center;

      i {
        cursor: pointer;
      }
    }
  }

  .chart {
    width: 100%;
    height: 200px;
  }
}
</style>